module.exports = __webpack_public_path__ + "static/media/tutoringhub.14c649ac.png";